import { render, staticRenderFns } from "./serviceCycle.vue?vue&type=template&id=2d2a6553&scoped=true"
import script from "./serviceCycle.vue?vue&type=script&lang=js"
export * from "./serviceCycle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d2a6553",
  null
  
)

export default component.exports